const defaultEklDomain = process.env.VUE_APP_PRODUCTION_EKL_DOMAIN
const defaultSsoDomain = process.env.VUE_APP_PRODUCTION_SSO_DOMAIN
const defaultEsccDomain = process.env.VUE_APP_PRODUCTION_ESCC_DOMAIN

const ApiConfig = {
  eklDomain: sessionStorage.getItem('eklDomain') == null ? defaultEklDomain : sessionStorage.getItem('eklDomain'),
  ssoDomain: sessionStorage.getItem('ssoDomain') == null ? defaultSsoDomain : sessionStorage.getItem('ssoDomain'),
  esccDomain: sessionStorage.getItem('esccDomain') == null ? defaultEsccDomain : sessionStorage.getItem('esccDomain'),
}

export default ApiConfig
